import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (!window.lightbox) return
    window.lightbox.init()
    window.lightbox.option({ resizeDuration: 200, maxWidth: 1300 })
  }
}
